// eslint-disable-next-line @typescript-eslint/no-explicit-any
function Card(props: any) {
	const { extra, children, ...rest } = props;
	return (
		<div className={`!z-5 shadow-card relative flex flex-col rounded-2xl bg-white bg-clip-border ${extra}`} {...rest}>
			{children}
		</div>
	);
}

export default Card;
